import './code-list.component.scss';

import { Component } from 'preact';

import type { Code } from '../../models/code.interface';
import { CodeState } from '../../models/code.interface';
import { PollingService } from '../../services/polling.service';
import { SingleApiService } from '../../services/single-api.service';
import { CodeComponent } from './code.component';

interface SingleCodesComponentProps {
  keyIds?: string | null;
}

interface SingleCodesComponentState {
  codes: Code[];
}

export class CodeListComponent extends Component<
  SingleCodesComponentProps,
  SingleCodesComponentState
> {
  private singleApiService: SingleApiService;
  private pollingService: PollingService;
  private pollingInterval: NodeJS.Timeout | null = null;

  constructor(props: SingleCodesComponentProps) {
    super(props);
    this.state = {
      codes: [],
    };
    this.singleApiService = new SingleApiService();
    this.pollingService = new PollingService();
  }

  componentDidMount(): void {
    this.fetchCodes();
  }

  componentWillUnmount(): void {
    this.pollingService.stopPolling(this.pollingInterval);
  }

  private fetchCodes(): void {
    const keyIds = this.props.keyIds
      ? this.props.keyIds.split(',').map((id) => id.trim())
      : undefined;
    this.singleApiService
      .fetchCodes(keyIds)
      .then((codes: Code[]) => {
        this.setState({ codes });
        this.managePolling(codes);
      })
      .catch((error) => {
        console.error('Error fetching QR codes:', error);
        this.setState({ codes: [] });
        this.pollingService.stopPolling(this.pollingInterval);
        this.pollingInterval = null;
      });
  }

  private hasProcessingCodes(codes: Code[]): boolean {
    return codes.some((code) => code.state === CodeState.PROCESSING);
  }

  private managePolling(codes: Code[]): void {
    if (this.hasProcessingCodes(codes)) {
      this.startPolling();
    } else {
      this.pollingService.stopPolling(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  private startPolling(): void {
    if (this.pollingInterval) {
      return;
    }

    const keyIds = this.props.keyIds
      ? this.props.keyIds.split(',').map((id) => id.trim())
      : undefined;

    this.pollingInterval = this.pollingService.startPolling(
      () => this.singleApiService.fetchCodes(keyIds),
      (codes: Code[]) => this.setState({ codes }),
      (codes: Code[]) => this.hasProcessingCodes(codes),
      30000
    );
  }

  render() {
    return (
      <div className="single-card-grid">
        {this.state.codes.map((code: Code) => (
          <CodeComponent key={code.code} code={code} />
        ))}
      </div>
    );
  }
}
